var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyPillarGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2h16v1a1 1 0 01-1 1H5a1 1 0 01-1-1V2zM4 21a1 1 0 011-1h14a1 1 0 011 1v1H4v-1zM6 5h12v1a1 1 0 01-1 1H7a1 1 0 01-1-1V5zM6 19h12v-1a1 1 0 00-1-1H7a1 1 0 00-1 1v1zM8 8h2v8H8zM11 8h2v8h-2zM14 8h2v8h-2z",
    fill: "#fff"
  })));
}
export default SvgStrategyPillarGeneral;